import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../../base/BaseEntity'
import { generateEntityId } from '../../generateEntityId'

/**
 * A generic owner's credit balance, denominated in its own currency, tenant-isolated via
 * the inherited `tenant` field. The currency is set once at account creation (first
 * grant/seed) from an explicit override or the app's `defaultCurrency`, and is immutable
 * thereafter (no mixed-currency balances).
 */
@ObjectType()
@InputType('CreditAccountInput')
@modelOptions({ schemaOptions: { timestamps: true, collection: 'aicreditaccounts' } })
export class CreditAccount extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('crac') })
  declare _id: string

  /**
   * Generic owner of this balance — a `User._id` (User billing scope) or a `Tenant._id`
   * (Tenant billing scope), resolved by `resolveBillingOwnerId`. Unique per tenant — see
   * CreditAccountSchema.
   */
  @Field(() => String)
  @Prop({ type: String, required: true })
  ownerId: string

  /** Fixed at creation; never re-denominated. */
  @Field(() => String)
  @Prop({ type: String, required: true })
  currency: string

  @Field(() => Float)
  @Prop({ type: Number, required: true, default: 0 })
  balance: number
}
